<template>
  <span>
    <v-tooltip right v-if="showNickname">
      <template v-slot:activator="{ on }">
        <!-- asListItem = false -->
        <v-avatar :size="size" v-on="on" v-if="!asListItem">
          <img :src="iconUrl" />
        </v-avatar>
        <!-- asListItem = true -->
        <v-list-item-avator :size="size" , v-on="on" v-if="asListItem">
          <img :src="iconUrl" />
        </v-list-item-avator>
      </template>
      <span> {{ nickname }}</span>
    </v-tooltip>
    <span v-else>
      <v-avatar :size="size" v-if="!asListItem">
        <img :src="iconUrl" />
      </v-avatar>
      <v-list-item-avator :size="size" , v-on="on" v-if="asListItem">
        <img :src="iconUrl" />
      </v-list-item-avator>
    </span>
  </span>
</template>

<script>
export default {
  name: 'UserIconComponent',
  props: {
    asListItem: { type: Boolean, required: false, default: false },
    showNickname: { type: Boolean, required: false, default: true },
    iconUrl: { type: String, required: false },
    nickname: { type: String, required: false },
    size: { type: [Number, String], required: false, default: 36 },
  },
}
</script>

<style scoped></style>
